  <template>
  <div class="scrollable-ctnr pt-6 pb-0 ma-0">
    <v-row class="row">
      <v-col class="pt-0 pb-0 ma-0">
        <CommonDropDowns :taxFeeRequired="true"
          :isItTaxFee="true"
          @change="dataFromCommonDropDowns"
          :v-model="editedItem.newFeeNumber"
        />
      </v-col>
    </v-row>
    <v-row class="row">
      <v-col class="pt-0 pb-0 ma-0">
        <v-text-field :rules="rulesFeeAmt"
          class="input-text-size"
          v-model="editedItem.newFeeAmount"
          label="Fee Amount" />
      </v-col>
    </v-row>
    <v-row class="row">
      <v-col class="pt-0 pb-0 ma-0">
        <ClarionDateControl
          class="input-text-size"
          :isToggle="false"
          v-model="editedItem.newEffectiveDate"
          label="Effective Date"
        />
      </v-col>
    </v-row>
    <v-row class="row">
      <v-col  class="pt-0 pb-0 ma-0">
        <h4>*This will override the previous values on All selected fee records</h4>
      </v-col>
    </v-row>
    </div>
  </template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
// import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'feeManagmentEditDialog',
  components: {
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item']),
    rulesFeeAmt() {
      return [
        (v) => !!v || 'Required.',
      ];
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val) {
      this.editedItem.newFeeNumber = val;
    },
  },
};
</script>
